export type JsonPrimitive = string | number | null;
export interface JsonMap<A> extends Record<string, A> {}
export type Json = JsonPrimitive | JsonMap<Json> | Json[];

export function removeNulls(obj: Json): Json {
  if (Array.isArray(obj)) {
    return obj.map(removeNulls);
  }

  if (obj && typeof obj === 'object') {
    const result: Json = {};
    for (const key of Object.keys(obj)) {
      if (obj[key] !== null) {
        result[key] = removeNulls(obj[key]);
      }
    }
    return result;
  }

  return obj;
}
